
      <!--  INPUT CONTROL  -->

      <div class="input-group control"
           [class.has-validators]="hasValidators"
           [class.has-password-strength]="passwordStrength"
           [class.is-invalid]="isInvalid"
           [class.focus]="isInFocus"
           [class.has-suffixes]="controlSuffixes.length > 0"
           [formGroup]="form">

          <!--  PREFIXES  -->

          <ng-template ngFor let-prefix [ngForOf]="controlPrefixes">

              <span class="prefix" [ngClass]="{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : prefix.event}">
                  <i *ngIf="prefix.icon" [ngClass]="prefix.icon"></i>
                  {{ prefix.text }}
              </span>

          </ng-template>


          <!--  END PREFIXES  -->

          <!--  CONTROL  -->

          <div>
              <input [id]="id"
                     [type]="inputType"
                     [formControlName]="name"
                     [attr.placeholder]="placeholder ? placeholder : null"
                     (change)="onChange($event)"
                     (keyup)="onKeyUp($event)"
                     (focus)="isInFocus = true"
                     (blur)="isInFocus = false"/>
          </div>

          <!--  END CONTROL  -->

          <!--  SUFFIXES  -->

          <ng-template ngFor let-suffix [ngForOf]="controlSuffixes" let-i="index">

              <span class="suffix" [class.last-child]="i === controlSuffixes.length - 1" [ngClass]="{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : suffix.event}">
                  <i *ngIf="suffix.icon" [ngClass]="suffix.icon"></i>
                  {{ suffix.text }}
              </span>

          </ng-template>

          <!-- END SUFFIXES  -->

          <!--  PASSWORD STRENGTH  -->

          <span *ngIf="passwordStrength"
                class="password-strength"
                [ngClass]="passwordStrength.containerClass"
                [uiTooltipText]="passwordStrength.tooltipText">
              <i [ngClass]="passwordStrength.iconClass"></i>
          </span>

          <!--  END PASSWORD STRENGTH  -->

          <!-- VALIDATION INDICATOR  -->

          <span *ngIf="hasValidators" class="invalid-indicator neg-bg neg-mix-hov-bg" [uiTooltipText]="invalidReasons.length > 0 ? invalidReasons : 'Invalid Value'">
      		<i class="fas fa-exclamation-circle neg-fg-col"></i>
      	</span>

          <!--  END VALIDATION INDICATOR  -->

      </div>

      <!--  END INPUT CONTROL  -->
    